var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	63631: () => (loadStrictVersion("default", "@grapecity/wijmo", false, [1,5,20241,9], () => (__webpack_require__.e(6901).then(() => (() => (__webpack_require__(86901))))))),
	86672: () => (loadSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	2503: () => (loadStrictVersion("default", "@grapecity/wijmo.odata", false, [1,5,20241,9], () => (__webpack_require__.e(4966).then(() => (() => (__webpack_require__(74966))))))),
	61167: () => (loadStrictVersion("default", "@tanstack/react-query", false, [1,5,59,15], () => (__webpack_require__.e(5946).then(() => (() => (__webpack_require__(85946))))))),
	50911: () => (loadStrictVersion("default", "@emotion/react", false, [1,11,13,3], () => (Promise.all([__webpack_require__.e(6917), __webpack_require__.e(1348)]).then(() => (() => (__webpack_require__(58967))))))),
	55912: () => (loadStrictVersion("default", "unified", false, [1,11,0,5], () => (__webpack_require__.e(6817).then(() => (() => (__webpack_require__(16817))))))),
	5247: () => (loadStrictVersion("default", "@casetext/pantheon", false, [3,0,0,1,,"287cd7fd"], () => (__webpack_require__.e(5098).then(() => (() => (__webpack_require__(35098))))))),
	5904: () => (loadStrictVersion("default", "@casetext/prometheus", false, [1,2,1,25], () => (Promise.all([__webpack_require__.e(7306), __webpack_require__.e(5006), __webpack_require__.e(141), __webpack_require__.e(8658), __webpack_require__.e(3631), __webpack_require__.e(4291), __webpack_require__.e(2503)]).then(() => (() => (__webpack_require__(38658))))))),
	21079: () => (loadStrictVersion("default", "lodash", false, [1,4,17,21], () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))))),
	53638: () => (loadSingletonVersion("default", "zustand", true, [1,4,5,2], () => (() => (__webpack_require__(34085))))),
	76554: () => (loadStrictVersion("default", "@casetext/basenji", false, [2,0,9,2], () => (__webpack_require__.e(243).then(() => (() => (__webpack_require__(80243))))))),
	66893: () => (loadStrictVersion("default", "@mui/material", false, [1,6,1,3], () => (Promise.all([__webpack_require__.e(3097), __webpack_require__.e(2389), __webpack_require__.e(6917), __webpack_require__.e(172), __webpack_require__.e(911)]).then(() => (() => (__webpack_require__(10172))))))),
	48173: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(2485).then(() => (() => (__webpack_require__(32485))))))),
	86843: () => (loadStrictVersion("default", "react-hook-form", false, [1,7,51,0], () => (__webpack_require__.e(7286).then(() => (() => (__webpack_require__(97286))))))),
	15634: () => (loadStrictVersion("default", "ky", false, [1,1,7,2], () => (__webpack_require__.e(9955).then(() => (() => (__webpack_require__(49955))))))),
	14067: () => (loadStrictVersion("default", "react-markdown", false, [1,9,0,1], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(4283), __webpack_require__.e(8883), __webpack_require__.e(6945), __webpack_require__.e(8606), __webpack_require__.e(5912)]).then(() => (() => (__webpack_require__(38606))))))),
	21084: () => (loadStrictVersion("default", "rehype-raw", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(4283), __webpack_require__.e(3790)]).then(() => (() => (__webpack_require__(13790))))))),
	30919: () => (loadStrictVersion("default", "rehype-sanitize", false, [1,6,0,0], () => (__webpack_require__.e(9515).then(() => (() => (__webpack_require__(99515))))))),
	64677: () => (loadStrictVersion("default", "date-fns", false, [1,3,6,0], () => (__webpack_require__.e(122).then(() => (() => (__webpack_require__(80122))))))),
	70811: () => (loadStrictVersion("default", "remark-gfm", false, [1,4,0,0], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(8883), __webpack_require__.e(2618)]).then(() => (() => (__webpack_require__(22618))))))),
	13469: () => (loadStrictVersion("default", "@tanstack/react-query-devtools", false, [1,5,59,15], () => (__webpack_require__.e(6695).then(() => (() => (__webpack_require__(56695))))))),
	63816: () => (loadStrictVersion("default", "@casetext/cocounsel-skill-mapping", false, [1,1,1,13], () => (__webpack_require__.e(8308).then(() => (() => (__webpack_require__(78308))))))),
	9705: () => (loadStrictVersion("default", "jszip", false, [1,3,10,1], () => (__webpack_require__.e(1710).then(() => (() => (__webpack_require__(71710))))))),
	46976: () => (loadStrictVersion("default", "react-virtuoso", false, [1,4,10,4], () => (__webpack_require__.e(5778).then(() => (() => (__webpack_require__(35778))))))),
	89674: () => (loadStrictVersion("default", "react-intersection-observer", false, [1,9,8,1], () => (__webpack_require__.e(9538).then(() => (() => (__webpack_require__(29538))))))),
	77171: () => (loadStrictVersion("default", "@mui/icons-material", false, [1,6,1,3], () => (Promise.all([__webpack_require__.e(3097), __webpack_require__.e(7359), __webpack_require__.e(911)]).then(() => (() => (__webpack_require__(47359))))))),
	44914: () => (loadSingletonVersion("default", "react", false, [1,18,2,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540)))))))
};
var initialConsumes = [44914];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"911": [
		50911
	],
	"1167": [
		61167
	],
	"1940": [
		14067,
		21084,
		30919,
		64677,
		70811
	],
	"2503": [
		2503
	],
	"2657": [
		5247,
		5904,
		21079,
		53638,
		76554
	],
	"3469": [
		13469
	],
	"3603": [
		63816
	],
	"3631": [
		63631
	],
	"3660": [
		77171
	],
	"4291": [
		86672
	],
	"5634": [
		15634
	],
	"5912": [
		55912
	],
	"6303": [
		48173,
		86843
	],
	"6525": [
		61167
	],
	"6672": [
		86672
	],
	"6893": [
		66893
	],
	"8556": [
		9705,
		46976,
		89674
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}